import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import checkboxState from './state';
const checkboxSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => checkboxState);
    },
    initialState: checkboxState,
    name: 'checkbox',
    reducers: {
        resetSelections: () => checkboxState,
        selectAllLocations: {
            prepare: locations => {
                return {
                    payload: {
                        locations
                    }
                };
            },
            reducer: (state, action) => {
                const { locations } = action.payload;
                state.selectedLocations = locations;
            }
        },
        selectAllNetworkInterfaces: {
            prepare: networkInterfaces => {
                return {
                    payload: {
                        networkInterfaces
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterfaces } = action.payload;
                state.selectedNetworkInterfaces = networkInterfaces;
            }
        },
        selectAllUsers: {
            prepare: users => {
                return {
                    payload: {
                        users
                    }
                };
            },
            reducer: (state, action) => {
                const { users } = action.payload;
                state.selectedUsers = users;
            }
        },
        selectLocation: {
            prepare: location => {
                return {
                    payload: {
                        location
                    }
                };
            },
            reducer: (state, action) => {
                const { location } = action.payload;
                state.selectedLocations.push(location);
            }
        },
        selectNetworkInterface: {
            prepare: networkInterface => {
                return {
                    payload: {
                        networkInterface
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterface } = action.payload;
                state.selectedNetworkInterfaces.push(networkInterface);
            }
        },
        selectUser: {
            prepare: user => {
                return {
                    payload: {
                        user
                    }
                };
            },
            reducer: (state, action) => {
                const { user } = action.payload;
                state.selectedUsers.push(user);
            }
        },
        unselectAllLocations: state => {
            state.selectedLocations = [];
        },
        unselectAllNetworkInterfaces: state => {
            state.selectedNetworkInterfaces = [];
        },
        unselectAllUsers: state => {
            state.selectedUsers = [];
        },
        unselectLocation: {
            prepare: location => {
                return {
                    payload: {
                        location
                    }
                };
            },
            reducer: (state, action) => {
                const { location } = action.payload;
                state.selectedLocations = state.selectedLocations.filter(item => {
                    return item !== location;
                });
            }
        },
        unselectNetworkInterface: {
            prepare: networkInterface => {
                return {
                    payload: {
                        networkInterface
                    }
                };
            },
            reducer: (state, action) => {
                const { networkInterface } = action.payload;
                state.selectedNetworkInterfaces = state.selectedNetworkInterfaces.filter(item => {
                    return item !== networkInterface;
                });
            }
        },
        unselectUser: {
            prepare: user => {
                return {
                    payload: {
                        user
                    }
                };
            },
            reducer: (state, action) => {
                const { user } = action.payload;
                state.selectedUsers = state.selectedUsers.filter(item => {
                    return item !== user;
                });
            }
        }
    }
});
export const { resetSelections, selectAllLocations, selectAllNetworkInterfaces, selectAllUsers, selectLocation, selectNetworkInterface, selectUser, unselectAllLocations, unselectAllNetworkInterfaces, unselectAllUsers, unselectLocation, unselectNetworkInterface, unselectUser } = checkboxSlice.actions;
export default checkboxSlice.reducer;
